import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/drug-interactions";

export const getDrugInteractionsById = (drugInteractionsId) => axios.get(API_PATH + "/get-by-id/" + drugInteractionsId)

export const deleteDrugInteractionsById = drugInteractionsId => axios.delete(API_PATH + '/mark-delete/' + drugInteractionsId);

export const saveOrUpdate = (searchObject) => axios.post(API_PATH + "/save-or-update", searchObject);

export const pagingDrugInteractions = searchDrugInteractions => axios.post(API_PATH + "/search-by-page", searchDrugInteractions);

export const getAllDrugInteractions = () => axios.get(API_PATH + "/get-all");

export const saveDrugInteractionSyncStore = (result) => axios.post(API_PATH + "/sync-drug-interactions", result);
